module.exports = __webpack_public_path__ + "static/media/verdeLips_wide.156cb432.jpg";